var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileExplorer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7638 9.22414C19.4506 9.22414 19.1966 8.96166 19.1966 8.63793V6H12.389C11.7624 6 11.2544 6.52495 11.2544 7.17241V20.069C11.2544 20.7164 11.7624 21.2414 12.389 21.2414H20.8984C21.525 21.2414 22.033 20.7164 22.033 20.069V9.22414H19.7638Z",
    fill: "var(--ion-color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8984 21.2414C21.525 21.2414 22.033 20.7164 22.033 20.0689C22.033 20.7164 21.525 21.2414 20.8984 21.2414Z",
    fill: "var(--ion-color-secondary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6729 10.6896C12.6729 11.0134 12.9269 11.2758 13.2401 11.2758C12.9273 11.2748 12.6738 11.0129 12.6729 10.6896Z",
    fill: "var(--ion-color-secondary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8988 21.2414H20.0479C20.0479 22.2125 20.8099 23 21.7497 23C22.6896 23 23.4516 22.2125 23.4516 21.2414V20.0689H22.0334C22.0334 20.7164 21.5254 21.2414 20.8988 21.2414Z",
    fill: "var(--ion-color-primary)",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0478 21.2414V12.4483C20.0478 11.8008 19.5398 11.2759 18.9132 11.2759H13.2403C12.927 11.2759 12.673 11.0134 12.673 10.6897V10.1035C12.673 9.45601 12.1649 8.93106 11.5384 8.93106H8.13459C7.50802 8.93106 7 9.45601 7 10.1035V21.2414C7 22.2126 7.76203 23 8.70189 23H21.7497C20.8099 23 20.0478 22.2126 20.0478 21.2414Z",
    fill: "var(--ion-color-primary)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7636 9.22414H22.0328L19.1963 6V8.63793C19.1963 8.96166 19.4503 9.22414 19.7636 9.22414Z",
    fill: "var(--ion-color-secondary)",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7785 8.05172H12.6728C12.5162 8.05172 12.3892 7.92048 12.3892 7.75862C12.3892 7.59675 12.5162 7.46552 12.6728 7.46552H17.7785C17.9351 7.46552 18.0621 7.59675 18.0621 7.75862C18.0621 7.92048 17.9351 8.05172 17.7785 8.05172Z",
    fill: "var(--ion-color-secondary)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7787 9.22415H13.8076C13.6509 9.22415 13.5239 9.09291 13.5239 8.93104C13.5239 8.76918 13.6509 8.63794 13.8076 8.63794H17.7787C17.9353 8.63794 18.0623 8.76918 18.0623 8.93104C18.0623 9.09291 17.9353 9.22415 17.7787 9.22415Z",
    fill: "var(--ion-color-secondary)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9713 21.5345H9.8367C9.05376 21.5335 8.41943 20.878 8.41846 20.069V18.8966C8.41846 18.7347 8.54546 18.6035 8.70211 18.6035C8.85875 18.6035 8.98575 18.7347 8.98575 18.8966V20.069C8.98575 20.5546 9.36677 20.9483 9.8367 20.9483H10.9713C11.1279 20.9483 11.2549 21.0796 11.2549 21.2414C11.2549 21.4033 11.1279 21.5345 10.9713 21.5345Z",
    fill: "var(--ion-color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExplorer);
export default __webpack_public_path__ + "static/media/file-explorer.b8673b4b.svg";
export { ForwardRef as ReactComponent };